import styled from "styled-components";
import { breakpoints, maxWidth } from "../../../styles/variables/breakpoints";
import { colors } from "../../../styles/variables/colors";

export const Button = styled.button`
  padding: 1.25rem 1.5rem;
  width: 100%;
  background-image: url(/modules/custom/custom_react_maps/img/localization.svg);
  background-size: 4rem;
  background-repeat: no-repeat;
  background-position: 95% 50%;
  background-color: ${colors.blue};
  transition: all 0.4s;
  color: white;
  border: none;
  padding-right: 6rem;
  margin: 0;
  font-weight: 500;
  font-size: 17px;
  line-height: 21px;
  ${maxWidth(breakpoints.lg)} {
    font-size: 13px;
    line-height: 18px;
    padding: 0.95rem 1.5rem;
    padding-right: 5rem;
    background-size: 3rem;
  }
  ${maxWidth(breakpoints.md)} {
    text-indent: -9999px;
    padding: 0.95rem 2.5rem;
    background-position: 50% 50%;
  }
  ${maxWidth(breakpoints.sm)} {
    padding: 0.95rem 2rem;
  }
  &:hover {
    background-color: ${colors.lightBlue};
  }
`;

export const TrackLocationButtonWrap = styled.div`
  margin-left: 2rem;
`;
